<template>
    <div class="AccordionCard">
        <div class="AccordionCard__in">
            <img src="/local/templates/main/img/icons/window.svg" alt="">
            <div class="AccordionCard__title">
                {{ _data.title }}
            </div>
            <div class="AccordionCard__fields" v-if="_data.fields">
                <div class="AccordionCard__field" v-for="field in _data.fields">
                    <div class="fieldTitle" :class="{opened: field.opened}" @click="toggle(field)">
                        {{ field.title }}
                    </div>
                    <transition name="fade">
                        <div class="fieldText" v-show="field.opened" v-html="field.text">

                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AccordionCard",
    props: ['data'],
    data: () => {
        return {
            _data: null
        }
    },
    created() {
        const arData = this.data?.fields?.map(field => {
            return {...field, ...{opened: false}}
        }) || []
        this._data = {
            title: this.data.title,
            fields: arData
        }
    },
    methods: {
        toggle(field) {
            field.opened = !field.opened
        }
    }
}
</script>

<style scoped lang="scss">
.AccordionCard {
    padding: 35px 30px;
    border: 1px solid var(--c-gray-700);
    border-radius: 6px;

    img {
        max-width: 45px;
        object-fit: contain;
        margin-bottom: 22px;
    }

    &__title {
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 20px;
    }

    .fieldText {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        padding-left: 25px;
        margin-bottom: 15px;
    }

    .fieldTitle {
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 13px;
        color: var(--c-primary-200);
        cursor: pointer;
        padding-left: 15px;
        display: flex;
        align-items: center;

        &::before {
            content: "";
            display: inline-block;
            position: relative;
            width: 10px;
            height: 10px;
            min-width: 10px;
            border: 2px solid transparent;
            border-left-color: var(--c-primary-200);
            border-bottom-color: var(--c-primary-200);
            transform: rotate(-45deg);
            transition: transform .4s;
            left: -12px;
            vertical-align: 3px;
        }

        &.opened::before {
            transform: rotate(135deg);
            vertical-align: 0;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .4s
}

.fade-enter,
.fade-leave-to

{
    opacity: 0
}
</style>